<template>
    <TransloadDetails :back="{ name: 'IncidentProcessTransload' }"/>
  </template>
  
  <script>
  import TransloadDetails from "@/components/3pl/IncidentAndRequest/Transload/TransloadDetails.vue";
  export default {
    components: { 
      TransloadDetails,
    },
  };
  </script>
  
  <style>
  </style>